import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Order} from '../../back-office/Models/Order';
import {ServiceRequest} from '../Models/ServiceRequest';
import {catchError, map} from 'rxjs/operators';
import {ServiceRemark} from '../Models/ServiceRemark';
import { AuthenticationService } from 'src/app/shared/Services/authentication.service';



@Injectable()
export class OrderService {
  constructor(private readonly helper: Helper, private readonly http: HttpClient, private readonly authService: AuthenticationService) {
  }



  public generateOrderTemp(order, kind, deliveryAt) {
    const query = deliveryAt ? '&delivery_at=' + deliveryAt : '';
    return this.http.post(
      environment.apiUrl + '/dealer-system/order/pdf?kind=' + kind + query,
      order,
      {
        responseType: 'arraybuffer' as 'json',
        observe: 'response'
      }
    ).pipe(
      map((resp: HttpResponse<ArrayBuffer>) => this.helper.fileDownloadMap(resp, true)),
      catchError(res => this.helper.catchError(res))
    );
  }

  public getInvoiceForAnOrder(orderId, kind) {
    return this.http.get(environment.apiUrl + '/dealer-system/order/' + orderId + '/pdf?kind=' + kind, {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      map((resp: HttpResponse<ArrayBuffer>) => this.helper.fileDownloadMap(resp))
    ).pipe(catchError(res => this.helper.catchError(res)));
  }

  public getOrders(gridData = new HttpParams(), params = new HttpParams(), scope = 'dealer-system') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/order/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getOrderNumbers(gridData , scope = 'dealer-system') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/order/order-numbers/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getQuotes(gridData = new HttpParams(), params = new HttpParams(), scope = 'dealer-system') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/quote/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getQuotesBackOffice(gridData = new HttpParams(), params = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/quote/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getDeliveryOrders(gridData = new HttpParams(), params = new HttpParams(), scope = 'dealer-system') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/order/delivery-order?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getOrder(orderId) {
    return this.http.get<any>(environment.apiUrl + '/dealer-system/order/' + orderId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getQuoteOrder(orderId) {
    return this.http.get<any>(environment.apiUrl + '/dealer-system/quote/' + orderId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getOrderSuccess(orderId) {
    return this.http.get<any>(environment.apiUrl + '/dealer-system/order/' + orderId + '/success')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getPdf(orderId: number, kind?: string) {
    const kindParam = kind ? `?kind=${kind}` : '';
    return this.http.get(
      environment.apiUrl + '/dealer-system/order/' + orderId + '/pdf' + kindParam,
      {
        responseType: 'arraybuffer' as 'json',
        observe: 'response'
      }
    ).pipe(
      map((resp: HttpResponse<ArrayBuffer>) => this.helper.fileDownloadMap(resp, true))
    ).pipe(catchError(res => this.helper.catchError(res)));
  }



  public getCustomFabricPackagingPdf(orderId) {
    return this.http.get(environment.apiUrl + '/dealer-system/order/' + orderId + '/custom-fabric-packaging-pdf', {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      map((resp: HttpResponse<ArrayBuffer>) => this.helper.fileDownloadMap(resp))
    ).pipe(catchError(res => this.helper.catchError(res)));
  }

  public sendPdf(orderId, email) {
    return this.http.post(environment.apiUrl + '/dealer-system/order/' + orderId, {'email': email})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageOrder(order: Order, action , id = null) {
    switch (action) {
      case 'update-quote':
        let updateQuoteRoute = '/dealer-system/quote/'
        return this.http.put<any>(environment.apiUrl + updateQuoteRoute + id, order)
          .pipe(catchError(res => this.helper.catchError(res)));
      case 'update-order':
        return this.http.put<any>(environment.apiUrl + '/dealer-system/order/' + id, order)
          .pipe(catchError(res => this.helper.catchError(res)));
      case 'new-quote':
        let newQuoteRoute = '/dealer-system/quote/'
        return this.http.post<any>(environment.apiUrl + newQuoteRoute, order)
          .pipe(catchError(res => this.helper.catchError(res)));
      case 'place-quote':
        let placeQuoteRoute = '/dealer-system/quote/place/'
        return this.http.put<any>(environment.apiUrl + placeQuoteRoute + id, order)
          .pipe(catchError(res => this.helper.catchError(res)));
      case 'new-order':
        return this.http.post<any>(environment.apiUrl + '/dealer-system/order/', order)
          .pipe(catchError(res => this.helper.catchError(res)));
    }
  }

  public manageServiceRequest(serviceRequest: ServiceRequest, id) {
    return this.http.post<any>(environment.apiUrl + '/dealer-system/order/' + id + '/service-request', serviceRequest)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageServiceRemark(serviceRemark: ServiceRemark, id) {
    return this.http.post<any>(environment.apiUrl + '/dealer-system/order/' + id + '/service-remark', serviceRemark)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public downloadOrder(gridData = new HttpParams()) {
    return this.http.get(environment.apiUrl + '/dealer-system/order/download-orders?' + gridData.toString(), {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      map((resp: any) => {
        const contentDispositionHeader = resp.headers.get('content-disposition');
        const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
        return {'url': window.URL.createObjectURL(new Blob([resp.body], {type: 'application/pdf'})), 'filename': result.replace(/"/g, '')};
      })
    ).pipe(catchError(res => this.helper.catchError(res)));
  }

  public cancelOrder(orderID) {
    return this.http.put<any>(environment.apiUrl + '/dealer-system/order/' + orderID + '/cancel', {id: orderID})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public cancelQuoteOrder(orderID) {
    return this.http.put<any>(environment.apiUrl + '/dealer-system/quote/' + orderID + '/cancel', {id: orderID})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getOption(id: number) {
    return this.http.get<any>(environment.apiUrl + '/dealer-system/order/structured-options/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  /**
   * A quote's options.
   *
   * `perElement` asks for the same shape the order endpoint returns - keyed by element, so
   * each option row stays with the element it belongs to. Without it the response is keyed
   * by article with the elements' options merged together, which is what the quote overview
   * and the confirmation view render.
   */
  public getQuoteOption(id: number, perElement = false) {
    return this.http.get<any>(environment.apiUrl + '/dealer-system/quote/structured-options/' + id
      + (perElement ? '?perElement=1' : ''))
      .pipe(catchError(res => this.helper.catchError(res)));
  }

}
